<template>
  <div>
    <v-container fluid tag="section" class="tabs py-0 pt-1">
      <v-tabs v-model="tab" background-color="transparent" show-arrows height="40">
        <v-tab active-class="v-tab-active-class">
          Users
        </v-tab>
        <!-- <v-tab active-class="v-tab-active-class">
          KeepFreeReasons
        </v-tab> -->
        <v-tab active-class="v-tab-active-class">
          Cancellations
        </v-tab>
        <v-tab active-class="v-tab-active-class">
          Markets
        </v-tab>
        <v-tab active-class="v-tab-active-class">
          Positions
        </v-tab>
        <v-tab active-class="v-tab-active-class">
          Imports
        </v-tab>
        <v-tab active-class="v-tab-active-class">
          Payments
        </v-tab>
      </v-tabs>
    </v-container>

    <v-container fluid tag="section" class="tabs-items pb-10">
      <v-tabs-items v-model="tab" class="transparent-background" touchless>
        <v-tab-item key="users" :transition="false" :reverse-transition="false">
          <AdminUsers />
        </v-tab-item>
        <!-- <v-tab-item key="keepFreeReasons" :transition="false" :reverse-transition="false">
          <AdminKeepFreeReasons />
        </v-tab-item> -->
        <v-tab-item key="cancellations" :transition="false" :reverse-transition="false">
          <AdminCancellations />
        </v-tab-item>
        <v-tab-item key="markets" :transition="false" :reverse-transition="false">
          <AdminMarkets />
        </v-tab-item>
        <v-tab-item key="positions" :transition="false" :reverse-transition="false">
          <AdminPositions />
        </v-tab-item>
        <v-tab-item key="imports" :transition="false" :reverse-transition="false">
          <AdminImports />
        </v-tab-item>
        <v-tab-item key="payments" :transition="false" :reverse-transition="false">
          <AdminStripePayments />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import AdminUsers from '@/views/components/admin/AdminUsers'
// import AdminKeepFreeReasons from '@/views/components/admin/AdminKeepFreeReasons'
import AdminCancellations from '@/views/components/admin/AdminCancellations'
import AdminMarkets from '@/views/components/admin/AdminMarkets'
import AdminPositions from '@/views/components/admin/AdminPositions'
import AdminImports from '@/views/components/admin/AdminImports'
import AdminStripePayments from '@/views/components/admin/AdminStripePayments'

export default {
  components: {
    AdminUsers,
    AdminCancellations,
    // AdminKeepFreeReasons,
    AdminMarkets,
    AdminPositions,
    AdminImports,
    AdminStripePayments,
  },
  data: () => ({
    tab: 'users',
  }),
}
</script>
